module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "placeholder": "电话"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader",
      "label": "点赞截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead
          },
          model: {
            value: (_vm.uploader),
            callback: function($$v) {
              _vm.uploader = $$v
            },
            expression: "uploader"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader2",
      "label": "评论截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead2
          },
          model: {
            value: (_vm.uploader2),
            callback: function($$v) {
              _vm.uploader2 = $$v
            },
            expression: "uploader2"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader3",
      "label": "转发截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead3
          },
          model: {
            value: (_vm.uploader3),
            callback: function($$v) {
              _vm.uploader3 = $$v
            },
            expression: "uploader3"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader4",
      "label": "再看截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead4
          },
          model: {
            value: (_vm.uploader4),
            callback: function($$v) {
              _vm.uploader4 = $$v
            },
            expression: "uploader4"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "label": "备注信息",
      "type": "textarea",
      "maxlength": "50",
      "placeholder": "备注信息",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07275886"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ttaskwai.vue
// module id = 524
// module chunks = 1